import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function WorkerFormDialog({
  open,
  onOpenChange,
  form,
  setForm,
  onSave,
  isEdit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isEdit ? "Edit employee" : "Add employee"}</DialogTitle>
          <DialogDescription>
            Employees can sign into the mobile app using Company ID + Employee ID + PIN.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Name</Label>
            <Input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              data-testid="worker-form-name"
            />
          </div>
          <div>
            <Label>Employee ID / employee code</Label>
            <Input
              value={form.employee_code}
              placeholder="Example: NR001"
              onChange={(e) =>
                setForm({ ...form, employee_code: e.target.value.toUpperCase() })
              }
              data-testid="worker-form-code"
            />
          </div>
          <div>
            <Label>Email (optional)</Label>
            <Input
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="worker-form-email"
            />
          </div>
          <div>
            <Label>{isEdit ? "New PIN (leave blank to keep current)" : "PIN (optional — auto generated if blank)"}</Label>
            <Input
              value={form.pin || ""}
              onChange={(e) => setForm({ ...form, pin: e.target.value })}
              placeholder="4–8 digits"
              data-testid="worker-form-pin"
            />
            <p className="text-xs text-slate-500 mt-1">Employees use Company + Employee code + PIN in the mobile app.</p>
          </div>
          <div>
            <Label>{isEdit ? "New PIN (leave blank to keep current PIN)" : "Mobile PIN (4-8 digits)"}</Label>
            <Input
              value={form.pin || ""}
              inputMode="numeric"
              placeholder="Example: 1234"
              onChange={(e) => setForm({ ...form, pin: e.target.value.replace(/\D/g, "") })}
              data-testid="worker-form-pin"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            className="bg-slate-900 hover:bg-slate-800"
            data-testid="worker-form-save"
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
